import EpisodePartSuggestions, {
  EpisodePartSuggestionsProps,
} from './EpisodePartSuggestions';

export default EpisodePartSuggestions;
export type { EpisodePartSuggestionsProps };
